export const toBase64 = (source: string) => base64_encode(utf16to8(source));
export const fromBase64 = (base64String: string) =>
  utf8_decode(base64_decode(base64String));

/**  base64编码*/
function base64_encode(str: string) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; //64个基本的编码
  let c1, c2, c3;
  const len = str.length; //需编码字符串的长度
  let i = 0;
  let out = ""; //输出
  while (i < len) {
    //位数不足情况
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      //一个字节 没有数据用 = 补上
      out += chars.charAt(c1 >> 2);
      out += chars.charAt((c1 & 0x3) << 4);
      out += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      //两个字节 没有数据用 = 补上
      out += chars.charAt(c1 >> 2);
      out += chars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
      out += chars.charAt((c2 & 0xf) << 2);
      out += "=";
      break;
    }
    //位数足的情况
    c3 = str.charCodeAt(i++);
    out += chars.charAt(c1 >> 2);
    out += chars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
    out += chars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
    out += chars.charAt(c3 & 0x3f);
  }

  return out;
}

/**  base64编码（中文转 Unicode 编码，避免出现乱码）*/
function utf16to8(str: string) {
  let out = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const c = str.charCodeAt(i);
    //返回指定位置的字符的 Unicode 编码
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i); //返回指定位置的字符
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
      //fromCharCode 是将 Unicode 编码转为一个字符
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    }
  }

  return out;
}

/**  base64解码*/
function base64_decode(input: string) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let output = "";
  let chr1, chr2, chr3;
  let enc1, enc2, enc3, enc4;
  let i = 0;
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  while (i < input.length) {
    enc1 = chars.indexOf(input.charAt(i++));
    enc2 = chars.indexOf(input.charAt(i++));
    enc3 = chars.indexOf(input.charAt(i++));
    enc4 = chars.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  return output;
}

/**  utf-8解码*  @parm : str 传入的字符串*/
function utf8_decode(str: string) {
  let string = "";
  let i = 0;
  let c = 0;
  let c1 = 0;
  let c2 = 0;
  while (i < str.length) {
    c = str.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if (c > 191 && c < 224) {
      c1 = str.charCodeAt(i + 1);
      string += String.fromCharCode(((c & 31) << 6) | (c1 & 63));
      i += 2;
    } else {
      c1 = str.charCodeAt(i + 1);
      c2 = str.charCodeAt(i + 2);
      string += String.fromCharCode(
        ((c & 15) << 12) | ((c1 & 63) << 6) | (c2 & 63)
      );
      i += 3;
    }
  }
  return string;
}
